


















































import Vue from 'vue'
import _ from 'lodash'
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'
import { FreeShiftPlanningGroup } from '@/model/master-data/FreeShiftPlanningGroup'

interface ComponentData {
  showErrorSnackbar: boolean
  planningGroupValidationRules: Array<Function>
  numberOfEmployeesValidationRules: Array<Function>
  offsetValidationRules: Array<Function>
  formData: FreeShiftPlanningGroup | undefined
}

export default Vue.extend({
  name: 'FreeShiftPlanningGroupEditorDialog',

  props: {
    show: {
      type: Boolean,
      default: false
    },

    allPlanningGroupList: {
      type: Array as () => Array<PlanningGroup>
    },

    departmentId: {
      type: Number
    },

    dialogData: {
      type: Object as () => FreeShiftPlanningGroup
    },

    title: String
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('masterData.shifts.required').toString()

    return {
      planningGroupValidationRules: [
        required
      ],
      numberOfEmployeesValidationRules: [
        required
      ],
      offsetValidationRules: [
        required
      ],
      showErrorSnackbar: false,
      formData: undefined
    }
  },

  computed: {
    planningGroupList (): Array<PlanningGroup> {
      let list: Array<PlanningGroup> = []

      if (this.departmentId) {
        list = this.allPlanningGroupList
          .filter((item: PlanningGroup) => item.department === this.departmentId)
      }
      return list
    },
  },

  watch: {
    dialogData (): void {
      this.resetForm()
    }
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
      this.resetForm()
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if (form.validate()) {
        if (this.formData) {
          const group: PlanningGroup | undefined = _.find(this.planningGroupList, { planningGroup: this.formData.planningGroup })
          if (group) {
            this.formData.planningGroupName = group.planningGroupName
            this.$emit('createNewPlanningGroup', this.formData)
            this.resetForm()
          } else {
            this.showErrorSnackbar = true
          }
        }
      }
    },

    resetForm () {
      const form: any = this.$refs['form']
      if(form) {
        form.resetValidation()
      }

      if (this.dialogData) {
        this.formData = _.cloneDeep(this.dialogData)
      } else {
        this.formData = new FreeShiftPlanningGroup(
          undefined,
          undefined,
          0,
          '',
          undefined,
          undefined,
          '',
          '',
          ''
        )
      }
    },

    onCancelButtonClick (): void {
      this.$emit('close')
      this.resetForm()
    }
  },

  created () {
    this.formData = new FreeShiftPlanningGroup(
      undefined,
      undefined,
      0,
      '',
      undefined,
      undefined,
      '',
      '',
      ''
    )
  }
})
